<template>
  <b-modal
    id="clock-out-modal"
    modal-class="timesheet-modal"
    title="Clock Out Tradie"
    ok-title="Clock Out"
    :ok-disabled="!form.date"
    @ok="$emit('ok', $event)"
    @hidden="$emit('hidden')"
  >
    <b-form-group label="Clocked In At">
      <b-form-input :value="form.clocked_in_at_display" readonly plaintext />
    </b-form-group>
    <b-form-group label="Date">
      <b-form-datepicker
        v-model="form.date"
        :max="today"
        locale="en-AU"
        today-button
        reset-button
        close-button
        show-decade-nav
      />
    </b-form-group>
    <b-form-group label="Time">
      <datetime-input v-model="form.time" type="time" />
    </b-form-group>
    <b-form-group label="Break (minutes)">
      <b-form-input v-model.number="form.break_minutes" type="number" min="0" />
    </b-form-group>
    <b-form-group label="Comment (optional)">
      <b-form-input v-model="form.comment" />
    </b-form-group>
  </b-modal>
</template>

<script>
import DatetimeInput from '@/components/timesheets/DatetimeInput.vue'

export default {
  name: 'TimesheetClockOutModal',
  components: { DatetimeInput },
  props: {
    form: { type: Object, required: true },
    today: { type: String, default: '' },
  },
}
</script>
